import type { ExclusiveLockedContentType } from '@/lib/cms/cosmic/types/CosmicProductType'
import { getExclusiveContent } from '@/lib/cms/getExclusiveContent'
import useGlobalStore from '@/store/useGlobalStore'
import { useEffect, useState } from 'react'

export const useGetExclusiveContent = () => {
  const {
    app: { locale },
  } = useGlobalStore()

  const [isLoading, setIsLoading] = useState(false)
  const [exclusiveContentData, setExclusiveContentData] =
    useState<ExclusiveLockedContentType | null>(null)

  useEffect(() => {
    ;(async () => {
      setIsLoading(true)
      const exclusiveContent = await getExclusiveContent({ locale })

      if (!exclusiveContent) {
        setIsLoading(false)
        setExclusiveContentData(null)
        return
      }

      if ('error' in exclusiveContent) {
        setIsLoading(false)
        setExclusiveContentData(null)
        return
      }

      setExclusiveContentData(exclusiveContent.exclusiveLockedContentData)
      setIsLoading(false)
    })()
  }, [locale])

  return { isLoading, exclusiveContentData }
}
